import * as searchGetters from './store/searchStore-getters'
import * as searchSetters from './store/searchStore-setters'
import * as filtersGetters from './store/filters-getters'
import * as filtersSetters from './store/filters-setters'
import * as dateFiltersGetters from './store/date-filters-getters'
import * as dateFiltersSetters from './store/date-filters-setters'

const receiveUrl = (url) => {
    // get the "key" parameter from query url
    if (url['q']) {
        let searchParams = {
            "key": url['q'],
        };
        searchSetters.setSearchParams(searchParams);
        searchSetters.setNewSearchParamsKey(url['q']);
    }

    // get the "key" and "param" parameter from query url
    if (url['q'] && url['dc']) {
        let searchParams = {
            "key": url['q'],
            "param": url['dc']
        };
        searchSetters.setSearchParams(searchParams);
        searchSetters.setNewSearchParamsKey(url['q']);
        searchSetters.setNewSearchParamsParam(url['dc']);
    }

    // get the "sorting" parameter from query url
    if (url['s']) {
        searchSetters.setNewSorting(url['s'])
    }

    // get the "rowsNum" parameter from query url
    if (url['ipp']) {
        searchSetters.setRowsNum(url['ipp'])
    }

    // get the "page" parameter from query url
    if (url['p']) {
        searchSetters.setPageStart(url['p'])
    }

    // get the filters from query url
    if (url['fq']) {
        let filtersQuery;

        filtersQuery = url['fq'].split("|");
        filtersQuery.forEach((el,index) => {
            let value = el.split(':');
            let fquery = {};

            fquery['name'] = value[0];
            fquery['filters'] = value[1].split(',');

            filtersSetters.setFilterParams(fquery)
        });
    }

    // get the date range from query url
    if (url['dr']) {
        let dateRange;
        dateRange = url['dr'].split("|");
        dateFiltersSetters.setDateFrom(dateRange[0])
        dateFiltersSetters.setDateFromStatic(dateRange[0])
        dateFiltersSetters.setDateTo(dateRange[1])
        dateFiltersSetters.setDateToStatic(dateRange[1])
        dateFiltersSetters.setDateGap({ start: dateRange[0], end: dateRange[1]})
    }
};

const dispatchUrl = () => {
    let queryUrlParams = {};

    //"q" - SearchParams.key parameter
    if (searchGetters.searchParams().key !== '*:*') {
        queryUrlParams["q"] = searchGetters.searchParams().key;
    }

    //"dc" - SearchParams.param parameter
    if (searchGetters.searchParams().param) {
        queryUrlParams["dc"] = searchGetters.searchParams().param;
    }

    //"p" - this.currentPage parameter
    if (searchGetters.currentPage() !== 1) {
        queryUrlParams["p"] = searchGetters.currentPage();
    }

    //"s" - this.sortingParam parameter
    if (searchGetters.searchParams().sorting) {
        queryUrlParams["s"] = searchGetters.searchParams().sorting;
    }

    //"ipp" - this.rowsNum parameter
    if (searchGetters.searchParams().rows !== 30) {
        queryUrlParams["ipp"] = searchGetters.searchParams().rows;
    }

    //"fq" - this.filterParams parameter
    if (!_.isEmpty(filtersGetters.getFilterParams())) {
        let objectFilters = filtersGetters.getFilterParams();
        let objectFiltersString = '';

        //filter query traversal - facets
        for (let value in objectFilters) {
            objectFiltersString += objectFilters[value].name;
            objectFiltersString += ":";

            //filter query traversal - parameters
            for (let params in objectFilters[value].filters) {
                objectFiltersString += objectFilters[value].filters[params];

                if (params != objectFilters[value].filters.length - 1) {
                    objectFiltersString += ",";
                }
            }

            if (value != objectFilters.length - 1) {
                objectFiltersString += "|";
            }
        }

        queryUrlParams["fq"] = objectFiltersString;
    }

    //"dr" - date range filter parameter
    if (dateFiltersGetters.getIsDate()) {
        queryUrlParams["dr"] = dateFiltersGetters.getDateFromStatic() + "|" + dateFiltersGetters.getDateToStatic();
    }

    let url = {query: queryUrlParams};
    return url
};


export {
    dispatchUrl,
    receiveUrl
}



// WEBPACK FOOTER //
// ./src/scripts/modules/url.js